var widget_default = {
  "card": "PTH-l",
  "link": "DUkCX",
  "container": "ceXhp",
  "image": "EY64z",
  "right": "zid-1",
  "cardLayout": "_5OpzR",
  "content": "Tnlry",
  "title": "eHIek",
  "subtitle": "gBBAt",
  "button": "X6gCl",
  "button_disabled": "hjFw2",
  "buttonText": "-lrmx",
  "slimLayout": "xahCk",
  "rtl": "PJciQ",
  "ltr": "zay-S"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
